<template>
  <b-modal
    v-model="$show"
    centered
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    :size="size"
    :title="
      type && type == 'Approve'
        ? 'Publish this micro-credential'
        : 'Change status of micro-credential'
    "
    :content-class="type && type === 'Approve' ? 'modal__publish-lu' : 'modal__change-lu-status'"
  >
    <h6 class="text-black-50">
      {{ detail_top }}

      <span v-if="showWarningText" class="text__alert-change-status">
        and it will affect the display of the stack that contains it.
      </span>
    </h6>

    <b-alert v-if="type && type == 'Approve'" variant="primary" show>
      <div class="font-weight-bold">
        <b>{{ learningUnit.name }}</b>
      </div>
    </b-alert>

    <b-alert v-if="learningUnit.is_published" ref="text__lu-name" variant="danger" show>
      <h6>
        <b>{{ learningUnit.name }}</b>
      </h6>
      <h6>{{ enrolledStudents }} enrolled student{{ enrolledStudents > 1 ? 's' : '' }}</h6>
    </b-alert>

    <h6 class="text-black-50">{{ detail_bottom }}</h6>

    <template #modal-footer="{ cancel }">
      <b-button variant="link" class="btn-link-dark" :disabled="isLoading" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="success" :disabled="isLoading" @click="clickConfirm()">
        <span v-if="!isLoading">Confirm</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
export default {
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    show: {
      type: Boolean,
      default: false
    },

    noCloseOnBackdrop: {
      type: Boolean,
      default: true
    },

    noCloseOnEsc: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: 'md'
    },

    type: {
      type: String,
      required: true
    },

    userEnrolled: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false,
      enrolledStudents: 0
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    detail_top() {
      return this.type && this.type == 'Approve'
        ? 'Your are going to publish this micro-credential'
        : 'Are you sure you want to change the status of this micro-credential. After the status has changed nobody can access this micro-credential anymore,';
    },

    detail_bottom() {
      return this.type && this.type == 'Approve'
        ? 'Click at the “Confirm” button to publish this micro-credential.'
        : 'Click at the “Confirm” button to change the status.';
    },

    showWarningText() {
      return this.type && this.type != 'Approve';
    }
  },

  watch: {
    learningUnit: {
      immediate: true,
      handler: 'getEnrolledStudents'
    }
  },

  methods: {
    getEnrolledStudents(learningUnit) {
      if (!learningUnit) return;
      this.enrolledStudents = 0;
      const { sections } = learningUnit;
      if (sections && sections.length > 0) {
        sections.forEach((section) => {
          this.enrolledStudents += section.user_enrollments_ids.length;
        });
      } else {
        this.enrolledStudents;
      }
    },

    async clickConfirm() {
      if (this.type) {
        try {
          if (this.type == 'Approve') {
            this.isLoading = true;
            await LearningUnit.api().publishLearningUnit(this.learningUnit.id);
            this.$emit('confirmed');
          }

          if (this.type == 'Draft') {
            this.isLoading = true;
            await LearningUnit.api().revertLearningUnit(this.learningUnit.id, {
              status: 'draft'
            });
            this.$emit('confirmed');
          }

          if (this.type == 'Submitted') {
            this.isLoading = true;
            await LearningUnit.api().revertLearningUnit(this.learningUnit.id, {
              status: 'submitted_for_publication'
            });
            this.$emit('confirmed');
          }
        } catch (error) {
          console.error('ConfirmModal error', error);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text__alert-change-status {
  color: red;
}
</style>
